module.exports = __webpack_public_path__ + "img/22.666550d2.png";